import { useMemo, useState, useEffect, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import useGetApi from "../../util/useGetApi";
import {
  NoPortfolio,
  SelectPortfolio,
  ChooseOwnPortfolio,
  // FinancialPlanning,
  AcceptPortfolio,
  DoneScreen,
  AuthorizedUser,
  GoalsBasedStart,
  GoalsOtherRetirementAccounts,
  GoalsRetirementAge,
  AnnualSalary,
  Contributions,
  RetirementGoalBalance,
  ReviewResults,
  HasPortfolioOnTrack,
  OffensiveGoalsBased,
  MaximizeBenefitsGoals,
  RtqStart,
  RtqOtherRetirementAccounts,
  RtqRetirementAge,
  WithdrawMoney,
  LargeExpenses,
  Confidence,
  Uncertainty,
  AccountBalance,
  InvestingPotential,
  PickingInvestments,
  InvestingConcepts,
  ExplainingTerms,
  MarketDrop,
  DefensiveRtq,
  Glidepath,
  MaximizeBenefits,
} from "./screens/index"; //All screen Components are pulled into this file, so just add the component name to this { }
import { useAppStore } from "../../store/store";

// Module-level flag to prevent double navigation (survives component re-mounts)
let isNavigating = false;
let navigationTimeout = null;

const ScreenWrapper = () => {
  const { screens, form, user, setScreen, setPreviousScreen } = useAppStore();
  const { screenId } = useParams();
  const [validInputs, setValidInputs] = useState(false);
  let navigate = useNavigate();

  const { callFormUpdate } = useGetApi();

  // const screen = screens.find(screen => screen.id === form.currentScreen);
  const screen = useMemo(
    () => screens.find((screen) => String(screen.id) === String(screenId)),
    [screenId, screens]
  );

  useEffect(() => {
    const popoverWrapper = document.querySelector(
      "[data-radix-popper-content-wrapper]"
    );
    if (popoverWrapper) {
      popoverWrapper.style.zIndex = "9999";
    }
  }, []);

  function renderScreen() {
    const currentFormQuestion = form.questions.find(
      (fq) => fq.questionId === screen.id
    );
    let initialValue = "";
    if (currentFormQuestion) initialValue = currentFormQuestion.answerKey;
    // Add a new case statement for each new screen component
    switch (screen.type) {
      case "no-portfolio":
        return (
          <NoPortfolio
            screen={screen}
            validation={validInputs}
            updateValidation={setValidInputs}
            value={initialValue}
            advanceScreen={advanceScreen}
            previousScreen={previousScreen}
          />
        );
      case "select-portfolio":
        return (
          <SelectPortfolio
            screen={screen}
            validation={validInputs}
            updateValidation={setValidInputs}
            value={initialValue}
            advanceScreen={advanceScreen}
            previousScreen={previousScreen}
          />
        );
      case "choose-own-portfolio":
        return (
          <ChooseOwnPortfolio
            screen={screen}
            validation={validInputs}
            updateValidation={setValidInputs}
            value={initialValue}
            advanceScreen={advanceScreen}
            previousScreen={previousScreen}
          />
        );
      case "financial-planning":
        return (
          // Previously, this routed to 1.8. Fallback to 1.9.
          // <FinancialPlanning
          //   screen={screen}
          //   validation={validInputs}
          //   updateValidation={setValidInputs}
          //   value={initialValue}
          //   advanceScreen={advanceScreen}
          //   previousScreen={previousScreen}
          // />
          <AcceptPortfolio
            screen={screen}
            validation={validInputs}
            updateValidation={setValidInputs}
            value={initialValue}
            advanceScreen={advanceScreen}
            previousScreen={previousScreen}
          />
        );
      case "accept-portfolio":
        return (
          <AcceptPortfolio
            screen={screen}
            validation={validInputs}
            updateValidation={setValidInputs}
            value={initialValue}
            advanceScreen={advanceScreen}
            previousScreen={previousScreen}
          />
        );
      case "done-screen":
        return (
          <DoneScreen
            screen={screen}
            validation={validInputs}
            updateValidation={setValidInputs}
            value={initialValue}
            advanceScreen={advanceScreen}
            previousScreen={previousScreen}
          />
        );
      case "authorized-user":
        return (
          <AuthorizedUser
            screen={screen}
            validation={validInputs}
            updateValidation={setValidInputs}
            value={initialValue}
            advanceScreen={advanceScreen}
            previousScreen={previousScreen}
          />
        );
      case "goals-based-start":
        return (
          <GoalsBasedStart
            screen={screen}
            validation={validInputs}
            updateValidation={setValidInputs}
            value={initialValue}
            advanceScreen={advanceScreen}
            previousScreen={previousScreen}
          />
        );
      case "goals-other-retirement-accounts":
        return (
          <GoalsOtherRetirementAccounts
            screen={screen}
            validation={validInputs}
            updateValidation={setValidInputs}
            value={initialValue}
            advanceScreen={advanceScreen}
            previousScreen={previousScreen}
          />
        );
      case "goals-retirement-age":
        return (
          <GoalsRetirementAge
            screen={screen}
            validation={validInputs}
            updateValidation={setValidInputs}
            value={initialValue}
            advanceScreen={advanceScreen}
            previousScreen={previousScreen}
          />
        );
      case "annual-salary":
        return (
          <AnnualSalary
            screen={screen}
            validation={validInputs}
            updateValidation={setValidInputs}
            value={initialValue}
            advanceScreen={advanceScreen}
            previousScreen={previousScreen}
          />
        );
      case "contributions":
        return (
          <Contributions
            screen={screen}
            validation={validInputs}
            updateValidation={setValidInputs}
            value={initialValue}
            advanceScreen={advanceScreen}
            previousScreen={previousScreen}
          />
        );
      case "retirement-goal-balance":
        return (
          <RetirementGoalBalance
            screen={screen}
            validation={validInputs}
            updateValidation={setValidInputs}
            value={initialValue}
            advanceScreen={advanceScreen}
            previousScreen={previousScreen}
          />
        );
      case "review-results":
        return (
          <ReviewResults
            screen={screen}
            validation={validInputs}
            updateValidation={setValidInputs}
            value={initialValue}
            advanceScreen={advanceScreen}
            previousScreen={previousScreen}
          />
        );
      case "has-portfolio-on-track":
        return (
          <HasPortfolioOnTrack
            screen={screen}
            validation={validInputs}
            updateValidation={setValidInputs}
            value={initialValue}
            advanceScreen={advanceScreen}
            previousScreen={previousScreen}
          />
        );
      case "offensive-goals-based":
        return (
          <OffensiveGoalsBased
            screen={screen}
            validation={validInputs}
            updateValidation={setValidInputs}
            value={initialValue}
            advanceScreen={advanceScreen}
            previousScreen={previousScreen}
          />
        );
      case "rtq-start":
        return (
          <RtqStart
            screen={screen}
            validation={validInputs}
            updateValidation={setValidInputs}
            value={initialValue}
            advanceScreen={advanceScreen}
            previousScreen={previousScreen}
          />
        );
      case "rtq-other-retirement-accounts":
        return (
          <RtqOtherRetirementAccounts
            screen={screen}
            validation={validInputs}
            updateValidation={setValidInputs}
            value={initialValue}
            advanceScreen={advanceScreen}
            previousScreen={previousScreen}
          />
        );
      case "rtq-retirement-age":
        return (
          <RtqRetirementAge
            screen={screen}
            validation={validInputs}
            updateValidation={setValidInputs}
            value={initialValue}
            advanceScreen={advanceScreen}
            previousScreen={previousScreen}
          />
        );
      case "withdraw-money":
        return (
          <WithdrawMoney
            screen={screen}
            validation={validInputs}
            updateValidation={setValidInputs}
            value={initialValue}
            advanceScreen={advanceScreen}
            previousScreen={previousScreen}
          />
        );
      case "large-expenses":
        return (
          <LargeExpenses
            screen={screen}
            validation={validInputs}
            updateValidation={setValidInputs}
            value={initialValue}
            advanceScreen={advanceScreen}
            previousScreen={previousScreen}
          />
        );
      case "confidence":
        return (
          <Confidence
            screen={screen}
            validation={validInputs}
            updateValidation={setValidInputs}
            value={initialValue}
            advanceScreen={advanceScreen}
            previousScreen={previousScreen}
          />
        );
      case "uncertainty":
        return (
          <Uncertainty
            screen={screen}
            validation={validInputs}
            updateValidation={setValidInputs}
            value={initialValue}
            advanceScreen={advanceScreen}
            previousScreen={previousScreen}
          />
        );
      case "account-balance":
        return (
          <AccountBalance
            screen={screen}
            validation={validInputs}
            updateValidation={setValidInputs}
            value={initialValue}
            advanceScreen={advanceScreen}
            previousScreen={previousScreen}
          />
        );
      case "investing-potential":
        return (
          <InvestingPotential
            screen={screen}
            validation={validInputs}
            updateValidation={setValidInputs}
            value={initialValue}
            advanceScreen={advanceScreen}
            previousScreen={previousScreen}
          />
        );
      case "picking-investments":
        return (
          <PickingInvestments
            screen={screen}
            validation={validInputs}
            updateValidation={setValidInputs}
            value={initialValue}
            advanceScreen={advanceScreen}
            previousScreen={previousScreen}
          />
        );
      case "investing-concepts":
        return (
          <InvestingConcepts
            screen={screen}
            validation={validInputs}
            updateValidation={setValidInputs}
            value={initialValue}
            advanceScreen={advanceScreen}
            previousScreen={previousScreen}
          />
        );
      case "explaining-terms":
        return (
          <ExplainingTerms
            screen={screen}
            validation={validInputs}
            updateValidation={setValidInputs}
            value={initialValue}
            advanceScreen={advanceScreen}
            previousScreen={previousScreen}
          />
        );
      case "market-drop":
        return (
          <MarketDrop
            screen={screen}
            validation={validInputs}
            updateValidation={setValidInputs}
            value={initialValue}
            advanceScreen={advanceScreen}
            previousScreen={previousScreen}
          />
        );
      case "defensive-rtq":
        return (
          <DefensiveRtq
            screen={screen}
            validation={validInputs}
            updateValidation={setValidInputs}
            value={initialValue}
            advanceScreen={advanceScreen}
            previousScreen={previousScreen}
          />
        );
      case "glidepath":
        return (
          <Glidepath
            screen={screen}
            validation={validInputs}
            updateValidation={setValidInputs}
            value={initialValue}
            advanceScreen={advanceScreen}
            previousScreen={previousScreen}
          />
        );
      case "maximize-benefits":
        return (
          <MaximizeBenefits
            screen={screen}
            validation={validInputs}
            updateValidation={setValidInputs}
            value={initialValue}
            advanceScreen={advanceScreen}
            previousScreen={previousScreen}
          />
        );
      case "maximize-benefits-goals":
        return (
          <MaximizeBenefitsGoals
            screen={screen}
            validation={validInputs}
            updateValidation={setValidInputs}
            value={initialValue}
            advanceScreen={advanceScreen}
            previousScreen={previousScreen}
          />
        );
      default:
        return;
    }
  }

  async function advanceScreen(e) {
    console.log('[ScreenWrapper] advanceScreen called:', {
      validation: validInputs,
      currentScreen: screen.id,
      userId: user?.userId,
    });
    
    if (validInputs) {
      try {
        console.log('[ScreenWrapper] Calling callFormUpdate...');
        const formResult = await callFormUpdate(form);
        console.log('[ScreenWrapper] callFormUpdate result:', formResult);
        
        if (formResult) {
          console.log('[ScreenWrapper] Calling setScreen...');
          const nextScreenId = await setScreen();
          console.log('[ScreenWrapper] Navigating to:', nextScreenId);
          navigate("/screen/" + nextScreenId);
        } else {
          console.error('[ScreenWrapper] Form update failed');
          alert("Can't advance because form didn't save");
        }
      } catch (error) {
        console.error('[ScreenWrapper] Error in advanceScreen:', error);
        alert("Error: " + error.message);
      }
    } else {
      console.log(`Cant advance because of ${validInputs}`);
    }
  }

  const previousScreen = useCallback(async (e) => {
    // Always prevent default behavior to avoid form submission or scrolling
    if (e) {
      e.preventDefault();
      e.stopPropagation();
      e.nativeEvent?.preventDefault();
      e.nativeEvent?.stopImmediatePropagation();

      // Prevent focus from changing (which can cause scrolling)
      if (e.target && typeof e.target.blur === 'function') {
        e.target.blur();
      }
    }

    // Prevent double-clicks using module-level flag (synchronous, survives re-mounts)
    if (isNavigating) {
      console.log('[ScreenWrapper] Already navigating, ignoring duplicate click');
      return;
    }

    // Clear any existing timeout
    if (navigationTimeout) {
      clearTimeout(navigationTimeout);
    }

    isNavigating = true;

    try {
      // Use the form's own screenHistory rather than browser history,
      // so Back works correctly after a fresh login (when browser history
      // contains the login page, not the prior form screens).
      const previousScreenId = await setPreviousScreen();
      if (!previousScreenId) {
        console.log('[ScreenWrapper] No back history — staying put');
        return;
      }
      console.log('[ScreenWrapper] Going back to:', previousScreenId);
      navigate('/screen/' + previousScreenId);
    } finally {
      // Reset the flag after navigation completes
      navigationTimeout = setTimeout(() => {
        isNavigating = false;
        navigationTimeout = null;
      }, 500);
    }
  }, [navigate, setPreviousScreen]);

  return (
    <div className="w-full">
      {/* <p className="absolute text-xs font-bold left-4 top-4">
        {screen.id}: {screen.heading}
      </p> */}
      {renderScreen()}
    </div>
  );
};

export default ScreenWrapper;
